import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  lastModified: '',
  lastRequestTime: null,
  contactFormState: {
    isFetching: false,
    isFetched: false,
    isFailed: false,
    item: null,
    errorMessage: '',
  },
}

export const contactSlice = createSlice({
  name: 'contact',
  initialState: initialState,
  reducers: {
    submitContactRequest: (state: any) => {
      state.contactFormState.isFetching = true
      state.contactFormState.isFetched = false
      state.contactFormState.isFailed = false
      state.contactFormState.errorMessage = ''
    },
    submitContactSuccess: (state: any, action) => {
      state.contactFormState.isFetching = false
      state.contactFormState.isFetched = true
      state.contactFormState.item = action.payload.item
    },
    submitContactFailure: (state: any, action) => {
      state.contactFormState.isFetching = false
      state.contactFormState.isFetched = true
      state.contactFormState.isFailed = true
      state.contactFormState.errorMessage = action.payload.errorMessage
    },
    resetContactFormState: (state: any) => {
      state.contactFormState = { ...initialState.contactFormState }
    },
  },
})

export const {
  submitContactRequest,
  submitContactSuccess,
  submitContactFailure,
  resetContactFormState,
} = contactSlice.actions

export default contactSlice.reducer
